import {
    update,
    makeKey,
    handleApiResponseError,
    handleNetworkError
} from '../../../../utils/reducerOperations';
import {toast} from '../../../../utils/messageUtils';

export function deleteActiveUserFailure(state, payload) {
    let response = makeKey(
        'deleteUserApi',
        update(state.deleteUserApi, {
            ...(payload.response && payload.response.data
                ? handleApiResponseError(payload.response.data)
                : handleNetworkError(payload)),
            userId: null
        })
    );
    toast.error(response.deleteUserApi.message);
    return response;
}
